module.exports = __webpack_public_path__ + "static/media/FoxWeeks-Pets-SalesSheet-2022.3281d372.9eca7599.pdf";